<template>
	<div class="fc-edit-detail fc-edit-address">
		<label>Edit Address</label>
		<form>
			<div class="fc-column">
				<label><span>*</span>FULL NAME</label>
				<input v-model="address.FullName" type="text" />
			</div>
			<div class="fc-column">
				<label><span>*</span>MOBILE NO.</label>
				<input v-model="address.MobileNo" type="text" />
			</div>
			<div class="fc-column">
				<label><span>*</span>POSTAL CODE</label>
				<input v-model="address.PostalCode" @blur="getAddress" minlength="6" maxlength="6" type="text" />
			</div>
			<div class="fc-column">
				<label><span>*</span>UNIT NO.</label>
				<input v-model="address.UnitNo" type="text" />
			</div>
			<div>
				<label>ADDRESS</label>
				<input v-model="address.Address" :placeholder="!findAddress ? 'Please fill in manually' : ''" type="text" />
			</div>
			<div>
				<label>BUILDING NAME</label>
				<input v-model="address.BuildingName" type="text" />
			</div>
			<div class="fc-checkbox">
				<input v-model="address.IsDefault" value="true" type="checkbox" />
				<label>Make default delivery address</label>
			</div>
			<div>
				<a @click="updateAddress">UPDATE ADDRESS</a>
			</div>
		</form>
	</div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'edit-address',
  data () {
    return {
      address: {}
    }
  },
  props: [
    'keyId'
  ],
  created () {
    this.address = {
      Address: this.keyId.Address,
      BuildingName: this.keyId.BuildingName,
      CustomersAddressId: this.keyId.CustomersAddressId,
      FullName: this.keyId.FullName,
      IsDefault: this.keyId.IsDefault,
      MobileNo: this.keyId.MobileNo,
      PostalCode: this.keyId.PostalCode,
      UnitNo: this.keyId.UnitNo
    }
  },
  methods: {
    updateAddress () {
      if (this.address.PostalCode.length !== 6) {
        $.alert({
          title: 'Notice',
          content: 'Invalid postal code',
          type: 'red',
          useBootstrap: false
        })
        return
      }
      this.$store.dispatch('customer/editAddress', this.address)
        .then(() => {
          this.$emit('close')
        })
    },
    getAddress: function () {
      if (this.address.PostalCode.length !== 6) {
        $.alert({
          title: 'Notice',
          content: 'Invalid postal code',
          type: 'red',
          useBootstrap: false
        })
        return
      }
      this.$store.dispatch('address/getAddress', this.address.PostalCode)
        .then(a => {
          if (a !== null) {
            this.findAddress = true
            this.address.Address = a.BLK_NO + ' ' + a.ROAD_NAME + ' ' + a.BUILDING
          } else {
            this.findAddress = false
            this.address.Address = ''
          }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/profile/EditAddress.vue